import { useStats } from '../../../lib/ctx/stats'
import { useStatsPermission, useStatsZeroState } from '../../../lib/hooks'
import { ReaderInsight } from '../../shared/ReaderInsight'
import { AvgRatingBarsContent } from './AvgRatingBarsContent'
import { StatsProfileBox } from '../../shared/stats_profile_box'
import pluralize from 'pluralize'
import { analytics } from 'segment_analytics'

export const AvgRatingBars = () => {
  const [yearStatus, stats] = useStats((s) => [s.yearStatus, s.stats])
  const avgRating = stats?.ratings?.average || 0
  const zeroState = useStatsZeroState('ratings')
  const { isStatsOwner } = useStatsPermission()
  const id = 'ratings'

  return (
    <StatsProfileBox
      id={id}
      data-testid={`stats-${id}`}
      text={{
        top: 'Average rating',
        main: avgRating.toString(),
        unit: pluralize('star', avgRating),
        infoText:
          'Add ratings and reviews to books in your Finished list, and we’ll calculate your average rating.',
      }}
      footer={
        isStatsOwner && zeroState && yearStatus === 'current' ? (
          <ReaderInsight
            data-testid="reader-insight-ratings"
            label="How to get started"
            text="Add ratings and reviews to books in your Finished list, and we’ll
        calculate your average rating."
          />
        ) : null
      }
      screenshot={{
        enabled: !zeroState,
        component: <AvgRatingBarsContent skipAnim />,
        onClick: () =>
          analytics.events.stats.statsShareTap({ type: 'ratings' }),
      }}
    >
      {zeroState ? null : <AvgRatingBarsContent />}
    </StatsProfileBox>
  )
}
